/** Add these props to anchor elements to make them open the link in a new tab. */ export const openInNewTabProps = {
    target: '_blank',
    rel: 'noopener'
};
